import moment from "moment";
import AbstractDriver from "./AbstractDriver";

export default class RollingWeekDriver extends AbstractDriver {
  constructor(from, to) {
    super();
    if (from) {
      this.from = moment(from);
      this.to = moment(to);
    } else {
      this._centerOn(moment());
    }
  }

  _centerOn(centerDate) {
    const center = moment(centerDate);
    this.from = center.clone().subtract(1, "week").startOf("isoWeek");
    this.to = center.clone().add(2, "weeks").endOf("isoWeek");
  }

  today() {
    this._centerOn(moment());
  }

  next() {
    this.from = this.from.clone().add(1, "week");
    this.to = this.to.clone().add(1, "week");
  }

  previous() {
    this.from = this.from.clone().subtract(1, "week");
    this.to = this.to.clone().subtract(1, "week");
  }

  nextMonth() {
    const from = this.from.clone().add(1, "month").startOf("month");
    this.from = from;
    this.to = from.clone().endOf("month");
  }

  previousMonth() {
    const from = this.from.clone().subtract(1, "month").startOf("month");
    this.from = from;
    this.to = from.clone().endOf("month");
  }

  getDateRange() {
    return { from: this.from, to: this.to };
  }

  switcherLabel() {
    const fromMonth = this.from.format("MMM");
    const toMonth = this.to.format("MMM");
    const fromYear = "'" + this.from.format("YY");
    const toYear = "'" + this.to.format("YY");

    if (fromYear !== toYear) {
      return `${fromMonth} ${fromYear} - ${toMonth} ${toYear}`;
    } else if (fromMonth !== toMonth) {
      return `${fromMonth} - ${toMonth} ${toYear}`;
    } else {
      return this.from.format("MMMM") + " " + fromYear;
    }
  }
}
